import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { HtmlContent } from 'utils';
import Container from 'components/Container';

import 'swiper/scss/navigation';
import styles from './styles/main.module.scss';

const AUTOPLAY_DELAY = 10000;

export const BannerSlider = ({ banners }) => {
  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;

    if (sliderRef.current.swiper.isBeginning) {
      sliderRef.current.swiper.slideTo(banners.length - 1);
      return;
    }

    sliderRef.current.swiper.slidePrev();
  }, [banners]);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;

    if (sliderRef.current.swiper.isEnd) {
      sliderRef.current.swiper.slideTo(0);
      return;
    }

    sliderRef.current.swiper.slideNext();
  }, []);

  if (banners === undefined) return null;

  const nextButtonClassNames = classNames(
    styles.navigation__button,
    styles.navigation__button_next,
  );

  const prevButtonClassNames = classNames(
    styles.navigation__button,
    styles.navigation__button_prev,
  );

  return (
    <div className={styles.banners}>
      <Container>
        <Swiper
          ref={sliderRef}
          modules={[Pagination, Autoplay, Navigation]}
          spaceBetween={15}
          slidesPerView={1}
          autoHeight={true}
          autoplay={{ delay: AUTOPLAY_DELAY, pauseOnMouseEnter: true }}
          pagination={{
            clickable: true,
            horizontalClass: styles.pagination,
            bulletActiveClass: styles.pagination__bullet_active,
            bulletClass: styles.pagination__bullet,
            lockClass: styles.pagination__bullet_lock,
          }}
          navigation={{
            nextEl: nextButtonClassNames,
            prevEl: prevButtonClassNames,
          }}
          className={styles.banners__slider}
        >
          {banners.map((el, i) => (
            <SwiperSlide
              key={i}
              style={{
                backgroundColor: `${el.background_color}`,
                backgroundImage: `url(${el.background_image})`,
              }}
              className={styles.banners__slider__item}
            >
              <div className={styles.banners__slider__item}>
                {el.text ? (
                  <div className={styles.banners__slider__text}>
                    <HtmlContent
                      content={el.text}
                      className={styles.banners__slider__content}
                    />
                  </div>
                ) : null}
                {el.image ? (
                  <img
                    src={el.image}
                    alt={el.image_alt || ''}
                    className={styles.banners__slider__image}
                  />
                ) : null}
              </div>
            </SwiperSlide>
          ))}
          <button className={nextButtonClassNames} onClick={handleNext} />
          <button className={prevButtonClassNames} onClick={handlePrev} />
        </Swiper>
      </Container>
    </div>
  );
};
